import React, { createContext, useContext, useState, useCallback } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const GlobalSnackbarContext = createContext(null);

export const GlobalSnackbarProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success'); // 'success' | 'info' | 'warning' | 'error'

    const showSnackbar = useCallback((msg, sev = 'success') => {
        setMessage(msg);
        setSeverity(sev);
        setOpen(true);
    }, []);

    const handleClose = useCallback((event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    }, []);

    return (
        <GlobalSnackbarContext.Provider value={{ showSnackbar }}>
            {children}
            <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            >
                <Alert
                    onClose={handleClose}
                    severity={severity}
                    sx={{
                        width: '100%',
                        borderRadius: '8px',
                        fontWeight: 500,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                    }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </GlobalSnackbarContext.Provider>
    );
};

export const useGlobalSnackbar = () => {
    const context = useContext(GlobalSnackbarContext);
    if (!context) {
        throw new Error('useGlobalSnackbar must be used within a GlobalSnackbarProvider');
    }
    return context;
};
